import React from "react";
import styled from "styled-components";
import { FaCheck, FaStar, FaRocket } from "react-icons/fa";
import colors from "../colors";

const PlansContainer = styled.div`
  padding: 20px 0;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const PlansWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 30px;
  padding: 0 50px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

const PlansTitle = styled.h2`
  font-size: 2.5rem;
  color: ${colors.darkPurple};
  margin-bottom: 64px;
  text-align: center;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const PlanCard = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease-in-out;
  position: relative;

  &:hover {
    transform: scale(1.02);
    transition: all 0.2s ease-in-out;
  }

  ${({ featured }) =>
    featured &&
    `
    border: 2px solid ${colors.purple};
    &:before {
      content: 'Mais Popular';
      position: absolute;
      top: -15px;
      background: ${colors.gradientButton};
      color: white;
      padding: 5px 15px;
      border-radius: 20px;
      font-size: 14px;
      font-weight: bold;
    }
  `}
`;

const PlanIcon = styled.div`
  height: 110px;
  width: 160px;
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: ${colors.purple};
`;

const PlanH2 = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: ${colors.darkPurple};
`;

const PlanPrice = styled.h3`
  font-size: 2.5rem;
  margin-bottom: 24px;
  color: ${colors.darkPurple};

  span {
    font-size: 1rem;
    color: #666;
  }
`;

const PlanFeatures = styled.ul`
  list-style: none;
  width: 100%;
  margin-bottom: 24px;
`;

const PlanFeature = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  color: #666;

  svg {
    margin-right: 10px;
    color: ${colors.purple};
  }
`;

const PlanButton = styled.a`
  border-radius: 50px;
  background: ${(props) =>
    props.primary ? colors.gradientButton : "transparent"};
  white-space: nowrap;
  padding: 12px 30px;
  color: ${(props) => (props.primary ? "#fff" : colors.purple)};
  font-size: 16px;
  outline: none;
  border: ${(props) => (props.primary ? "none" : `1px solid ${colors.purple}`)};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  width: 100%;
  text-align: center;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${(props) => (props.primary ? "#fff" : colors.purple)};
    color: ${(props) => (props.primary ? colors.purple : "#fff")};
    border: ${(props) =>
      props.primary
        ? `1px solid ${colors.purple}`
        : `1px solid ${colors.purple}`};
  }
`;

const TestimonialSection = styled.section`
  padding: 100px 0;
  background: ${colors.darkPurple};
  color: #fff;
`;

const TestimonialContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
`;

const TestimonialTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 64px;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const TestimonialWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 30px;

  @media screen and (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

const TestimonialCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 30px;
  text-align: left;
  position: relative;

  &:before {
    content: '"';
    position: absolute;
    top: 10px;
    left: 20px;
    font-size: 60px;
    color: rgba(255, 255, 255, 0.2);
    font-family: serif;
  }
`;

const TestimonialText = styled.p`
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${colors.gradientPrimary};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  font-size: 20px;
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.h4`
  font-size: 18px;
  margin-bottom: 5px;
`;

const AuthorRole = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
`;

const Amplie = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  .titulo-amplie {
    width: 100%;
    h2 {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    justify-content: center;
    li {
      width: 40%;
    }
  }
  svg {
    height: 50px;
    width: 50px;
  }
      @media screen and (max-width: 768px) {
    ul {
      flex-direction: column;
      align-items: center;
      li {
        width: 100%;
      }
    }
  }
`;

const PlansSection = () => {
  return (
    <>
      <Amplie>
        <section
          id="card"
          class="section-amplie bg-gray-lightest py-4 py-md-5 pb-xl-0 pos-relative"
        >
          <div class="container pos-relative">
            <div class="titulo-amplie row mb-3">
              <div class="col-lg-8 offset-lg-2 text-xs-center">
                <h2 class="h1-sm font-normal">
                  Amplie sua equipe, não os custos
                </h2>
              </div>
            </div>

            <div class="row">
              <ul class="list-icon flex-md-row">
                <li class="flex-item p-3 p-sm-4">
                  <figure class="list-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      viewBox="0 0 504.2 504.2"
                      class="img-svg img-3x"
                    >
                      <path
                        d="M252.1,0C113.1,0,0,113.1,0,252.1c0,42,10.6,83.6,30.6,120.4l-13.4,46.9c-5.5,19.1-.1,39.7,13.9,53.7,14,14,34.6,19.4,53.7,13.9l47-13.4c36.7,20,78.3,30.6,120.3,30.6,139,0,252.1-113.1,252.1-252.1S391.1,0,252.1,0ZM252.1,460.6c-37.5,0-74.3-10.1-106.3-29.2-3.4-2-7.2-3.1-11.2-3.1-2,0-4,.3-6,.8,0,0-27.8,7.9-55.8,16-3.9,1.1-8,0-10.9-2.8-2.8-2.8-3.9-7-2.8-10.9l16-55.8c1.7-5.8.8-12-2.2-17.2-19.1-32.1-29.2-68.8-29.2-106.4,0-114.9,93.5-208.5,208.5-208.5s208.5,93.5,208.5,208.5c-.1,115-93.7,208.6-208.6,208.6ZM350.8,164.5h-197.4c-12,0-21.8,9.8-21.8,21.8s9.8,21.8,21.8,21.8h197.4c12,0,21.8-9.8,21.8-21.8,0-12-9.8-21.8-21.8-21.8ZM350.8,230.3h-197.4c-12,0-21.8,9.8-21.8,21.8s9.8,21.8,21.8,21.8h197.4c12,0,21.8-9.8,21.8-21.8,0-12-9.8-21.8-21.8-21.8ZM252.1,296.1h-98.7c-12,0-21.8,9.8-21.8,21.8s9.8,21.8,21.8,21.8h98.7c12,0,21.8-9.8,21.8-21.8s-9.8-21.8-21.8-21.8Z"
                        style={{ fill: "#747BFF" }}
                      ></path>
                    </svg>
                  </figure>
                  <h3 class="h5 mb-2">Conversas naturais e inteligentes</h3>
                  <p>
                    Sua inteligência artificial vai muito além de respostas automatizadas – 
                    ela qualifica com precisão, resolve dúvidas na hora e guia o cliente 
                    de forma estratégica. Tudo isso com interações naturais, empáticas e 
                    sob medida para vender e encantar.
                  </p>
                </li>
                <li class="flex-item p-3 p-sm-4">
                  <figure class="list-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      viewBox="0 0 24 24"
                      class="img-svg img-3x"
                    >
                      <path
                        d="M15,13c0-1.7-1.3-3-3-3s-3,1.3-3,3,1.3,3,3,3,3-1.3,3-3ZM11,13c0-.6.4-1,1-1s1,.4,1,1-.4,1-1,1-1-.4-1-1ZM12,5c-3.9,0-7,3.1-7,7,0,1,.2,2,.7,3,.2.5.8.7,1.3.5s.7-.8.5-1.3c-.3-.8-.5-1.5-.5-2.2,0-2.8,2.2-5,5-5s5,2.2,5,5c0,.7-.2,1.4-.5,2.1-.2.5,0,1.1.5,1.3.1.1.3.1.4.1.4,0,.7-.2.9-.6.5-.9.7-1.9.7-2.9,0-3.9-3.1-7-7-7ZM12,0C5.4,0,0,5.4,0,12c0,2.2.6,4.4,1.8,6.3.3.5.9.6,1.4.3.5-.3.6-.9.3-1.4-1-1.5-1.5-3.3-1.5-5.2,0-5.5,4.5-10,10-10s10,4.5,10,10c0,1.9-.5,3.7-1.5,5.3-.3.5-.2,1.1.3,1.4.2.1.3.2.5.2.3,0,.7-.2.8-.5,1.2-1.9,1.8-4.1,1.8-6.3C24,5.4,18.6,0,12,0ZM15,17h-6c-1.7,0-3,1.3-3,3v3c0,.6.4,1,1,1s1-.4,1-1v-3c0-.6.4-1,1-1h6c.6,0,1,.4,1,1v3c0,.6.4,1,1,1s1-.4,1-1v-3c0-1.7-1.3-3-3-3Z"
                        style={{ fill: "#747BFF" }}
                      ></path>
                    </svg>
                  </figure>
                  <h3 class="h5 mb-2">
                    Enquanto sua equipe está Off a IA estão On
                  </h3>
                  <p>
                    Com IA, sua empresa pode crescer sem limites e sem
                    comprometer o orçamento. Seu novo time virtual opera
                    incansavelmente 24/7, atendendo milhares de clientes com bom
                    humor e vontade de trabalhar.
                  </p>
                </li>
                {/* <li class="flex-item p-3 p-sm-4">
                  <figure class="list-item-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      viewBox="0 0 24 24"
                      class="img-svg img-3x"
                    >
                      <path
                        d="M11,9h.5c.5.1,1.1-.3,1.2-.8.1-.5-.3-1.1-.8-1.2h-.9c-3.3,0-6,2.7-6,6s2.7,6,6,6,6-2.7,6-6c0-.3,0-.6-.1-.8-.1-.5-.6-.9-1.1-.9-.5.1-.9.6-.9,1.1v.5c0,2.2-1.8,4-4,4s-4-1.8-4-4,1.9-3.9,4.1-3.9ZM19.4,7.5c-.5.3-.7.9-.4,1.3.7,1.3,1,2.7,1,4.1,0,5-4,9-9,9S2,17.9,2,12.9,6,3.9,11,3.9c1.5,0,2.9.4,4.2,1,.5.3,1.1.1,1.4-.4.3-.5.1-1.1-.4-1.3-1.6-.8-3.4-1.2-5.2-1.2C4.9,2,0,6.9,0,13s4.9,11,11,11,11-4.9,11-11c0-1.8-.4-3.5-1.2-5.1-.3-.4-.9-.6-1.4-.4ZM23,3h-2V1c0-.6-.4-1-1-1s-1,.4-1,1v2.7l-8.7,8.6c-.4.4-.4,1,0,1.4.2.2.5.3.7.3.3,0,.5-.1.7-.3l8.7-8.6,2.6-.1c.6,0,1-.5,1-1,0-.6-.5-1-1-1Z"
                        style={{ fill: "#747BFF" }}
                      ></path>
                    </svg>
                  </figure>
                  <h3 class="h5 mb-2">Tráfego Pago + Agente IA</h3>
                  <p>
                    Aumente suas conversões substituindo landing pages por
                    Agentes IA em suas campanhas de tráfego pago. Na própria
                    Umbler, a maior parte do nosso tráfego pago no Instagram já
                    vai direto para o WhatsApp, onde nossos Agentes IA,
                    treinados para atuar como SDRs, fazem o show.
                  </p>
                </li> */}
              </ul>
            </div>
          </div>
        </section>
      </Amplie>

      <PlansContainer id="planos">
        <PlansTitle>Escolha o plano ideal para o seu negócio</PlansTitle>
        <PlansWrapper>
          {/* <PlanCard>
            <PlanIcon>
              <FaRocket />
            </PlanIcon>
            <PlanH2>Básico</PlanH2>
            <PlanPrice>
              R$ 97<span>/mês</span>
            </PlanPrice>
            <PlanFeatures>
              <PlanFeature>
                <FaCheck /> 1 Funcionário de IA
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Atendimento 24/7
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Suporte por email
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Integração WhatsApp
              </PlanFeature>
            </PlanFeatures>
            <PlanButton href="/#teste">Começar Teste Grátis</PlanButton>
          </PlanCard> */}

          <PlanCard featured>
            <PlanIcon>
              <FaRocket />
            </PlanIcon>
            <PlanH2>Venda Mais+</PlanH2>
            {/* <PlanPrice>
              R$ 197<span>/mês</span>
            </PlanPrice> */}
            <PlanFeatures>
              <PlanFeature>
                <FaCheck /> 1 Funcionário de IA
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Atendimento 24/7
              </PlanFeature>
              {/* <PlanFeature>
                <FaCheck /> Suporte prioritário
              </PlanFeature> */}
              <PlanFeature>
                <FaCheck /> Integração WhatsApp e Instagram
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Personalização
              </PlanFeature>
            </PlanFeatures>
            <PlanButton
              primary
              href="https://wa.me/551152868938?text=Olá%2C%20gostaria%20de%20mais%20informações"
              target="_blank"
            >
              Começar agora
            </PlanButton>
          </PlanCard>

          {/* <PlanCard>
            <PlanIcon>
              <FaRocket />
            </PlanIcon>
            <PlanH2>Empresarial</PlanH2>
            <PlanPrice>
              R$ 497<span>/mês</span>
            </PlanPrice>
            <PlanFeatures>
              <PlanFeature>
                <FaCheck /> 10 Funcionários de IA
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Atendimento 24/7
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Suporte VIP
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Todas as integrações
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Personalização completa
              </PlanFeature>
              <PlanFeature>
                <FaCheck /> Treinamento exclusivo
              </PlanFeature>
            </PlanFeatures>
            <PlanButton href="/#teste">Começar Teste Grátis</PlanButton>
          </PlanCard> */}
        </PlansWrapper>
      </PlansContainer>

      <TestimonialSection id="depoimentos">
        <TestimonialContainer>
          <TestimonialTitle>O que nossos clientes dizem</TestimonialTitle>
          <TestimonialWrapper>
            <TestimonialCard>
              <TestimonialText>
                "Antes, nossa equipe perdia horas com perguntas repetitivas. Com
                a iadevenda, resolvemos 80% das solicitações sem intervenção
                humana e reduzimos o tempo de resposta em 40%. Os clientes
                adoram a agilidade!"
              </TestimonialText>
              <TestimonialAuthor>
                <AuthorAvatar>
                  <FaStar />
                </AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>Juliana Lima</AuthorName>
                  {/* <AuthorRole>CEO, Tech Solutions</AuthorRole> */}
                </AuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>

            <TestimonialCard>
              <TestimonialText>
                "Nossa loja online operava apenas em horário comercial. Com a
                iadevenda, passamos a atender clientes de madrugada e finais de
                semana, aumentando as vendas em 15% sem precisar expandir a
                equipe."
              </TestimonialText>
              <TestimonialAuthor>
                <AuthorAvatar>
                  <FaStar />
                </AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>Renato Alves</AuthorName>
                  {/* <AuthorRole>Diretor Comercial, Global Shop</AuthorRole> */}
                </AuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>

            <TestimonialCard>
              <TestimonialText>
                "Hoje, não consigo imaginar nosso negócio sem a iadevenda. Para
                empresas que ainda têm dúvidas, meu conselho é: não esperem. A
                IA não é o futuro; é o presente, e quem não se adaptar vai ficar
                para trás."
              </TestimonialText>
              <TestimonialAuthor>
                <AuthorAvatar>
                  <FaStar />
                </AuthorAvatar>
                <AuthorInfo>
                  <AuthorName>Ana Costa</AuthorName>
                  {/* <AuthorRole>Gerente de Atendimento, Mega Store</AuthorRole> */}
                </AuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>
          </TestimonialWrapper>
        </TestimonialContainer>
      </TestimonialSection>
    </>
  );
};

export default PlansSection;
